import { constants } from '@/consts'

// initial state
const state = {
  title: constants.TITLE,
  notification: null,
  version: localStorage.getItem(constants.VERSION)
}

// getters
const getters = {
  title: (state) => {
    return state.title
  },
  notification: (state) => {
    return state.notification
  },
  version: (state) => {
    return state.version
  }
}

const mutations = {
  setTitle (state, payload) {
    if (payload.title) {
      state.title = `${constants.TITLE} - ${payload.title}`
    } else {
      state.title = `${constants.TITLE}`
    }
  },
  setNotification (state, payload) {
    state.notification = payload.notification
  },
  setVersion (state, payload) {
    localStorage.setItem(constants.VERSION, payload.version)
    state.version = payload.version
  }
}

// actions
const actions = {
  setTitle: ({ commit }, params) => {
    commit({ type: 'setTitle', title: params.title })
  },
  setNotification: ({ commit }, params) => {
    commit({ type: 'setNotification', notification: params.notification })
  },
  setVersion: ({ commit }, params) => {
    commit({ type: 'setVersion', version: params.version })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
